import { render } from "./App.vue?vue&type=template&id=c1cf84a8&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=c1cf84a8&lang=scss"

import exportComponent from "/Volumes/Media/WebDevelop/enfint-email/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__